export default "__VITE_ASSET__Uu_7Q25k__"